module.exports = __webpack_public_path__ + "static/media/ic_plc_women_colored.1ea62f0d.svg";